var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var NumberClassError = /** @class */ (function (_super) {
    __extends(NumberClassError, _super);
    function NumberClassError(msg) {
        var _this = _super.call(this, msg) || this;
        Object.setPrototypeOf(_this, NumberClassError.prototype);
        return _this;
    }
    return NumberClassError;
}(Error));
export { NumberClassError };
var DataArrayError = /** @class */ (function (_super) {
    __extends(DataArrayError, _super);
    function DataArrayError(msg) {
        var _this = _super.call(this, msg) || this;
        Object.setPrototypeOf(_this, DataArrayError.prototype);
        return _this;
    }
    return DataArrayError;
}(Error));
export { DataArrayError };
